import { useReducer } from 'react';
import { removeStoredAuthTokens, storeAuthTokens } from 'shared';

import { persistAuthState, resetAuthState, retrieveAuthState } from './utils/persist-auth-state';
import { DEFAULT_AUTH_STATE } from './constants';
import type { Action, State } from './types';

const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case 'authorize': {
      const { authTokens, address } = action.payload;
      const newState = { isAuthorized: true, authTokens, address };

      storeAuthTokens(authTokens);
      persistAuthState(newState);

      return newState;
    }
    case 'disconnect': {
      resetAuthState();
      removeStoredAuthTokens();

      return DEFAULT_AUTH_STATE;
    }
    default: {
      return state;
    }
  }
};

export const useStore = () => {
  return useReducer(reducer, DEFAULT_AUTH_STATE, (fallback) => retrieveAuthState() ?? fallback);
};
